export class FormattedDate {
  constructor(locale = "en-ZA") {
    this.locale = locale;
  }

  simpleFormat(createdAt) {
    const date = new Date(createdAt);
    const now = new Date();

    const isToday = now.toDateString() === date.toDateString();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    const isYesterday = yesterday.toDateString() === date.toDateString();

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    if (isToday) {
      return `Today, ${hours}:${minutes}`;
    }

    if (isYesterday) {
      return `Yesterday, ${hours}:${minutes}`;
    }

    return date.toLocaleDateString(this.locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  detailedFormat(createdAt) {
    const dateObj = new Date(createdAt);

    const date = dateObj.toLocaleDateString(this.locale, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const hours = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const seconds = dateObj.getSeconds().toString().padStart(2, "0");

    const timezoneOffset = -dateObj.getTimezoneOffset();
    const offsetHours = Math.floor(timezoneOffset / 60)
      .toString()
      .padStart(2, "0");
    const offsetSign = timezoneOffset >= 0 ? "+" : "-";

    const time = `${hours}:${minutes}:${seconds} (GMT${offsetSign}${offsetHours})`;

    return { date, time };
  }
}
